import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BillInfo } from '@cms-max/medicare-api-sdk'
import { TooltipIcon } from '@cmsgov/ds-medicare-gov'
import { MyTooltip } from 'components/MyTooltip'
import classes from './PremiumBillCard.module.scss'
import { useEvent } from 'hooks/useEvent'

export interface PremiumBillCardInfoProps {
  bill: BillInfo
}

export const PremiumBillCardInfo: FC<PremiumBillCardInfoProps> = ({ bill }) => {
  const { t } = useTranslation('premiumsBills', { keyPrefix: 'billCard' })
  const lastBillDateObject = new Date(bill.lastBillDate)
  const lastBillDateDisplay = `${(lastBillDateObject.getUTCMonth() + 1).toString().padStart(2, '0')}/${lastBillDateObject.getUTCDate().toString().padStart(2, '0')}/${lastBillDateObject.getUTCFullYear()}`
  const { fireEvent } = useEvent('premiumBills')

  return (
    <div className={`${classes.premiumBillCardInfo} ds-text-body--md`}>
      <dl>
        <dt>{t('billDate')}</dt>
        <dd>{lastBillDateDisplay}</dd>
        {bill.billType && (
          <>
            <dt>
              {t('billType')}
              {bill.isDelinquent && (
                <MyTooltip
                  ariaLabel={t('billTypeTooltipAria')}
                  className='ds-c-tooltip__trigger-icon'
                  title={t('billTypeTooltip')}
                  data-testid='billTypeTooltip'
                  onOpen={() => {
                    fireEvent('premiums_premiumbills_billtype_hover')
                  }}
                >
                  <TooltipIcon/>
                </MyTooltip>
              )}
            </dt>
            <dd>{bill.billType}</dd>
          </>
        )}
        <dt>{t('billPeriod')}</dt>
        <dd>{t('formattedBillDate', { month: ('0' + bill.forPremiumsThrough.month).slice(-2), year: bill.forPremiumsThrough.year })}</dd>
      </dl>
    </div>
  )
}
